import flatMap from 'lodash/flatMap'
import {
  StaticJourneyPageFragment,
  StaticMilestonePageFragment,
  MilestoneCardFragment,
  SubmilestoneCardFragment,
  ArticleCardFragment,
  GroupCardFragment,
  ResourcePageCardFragment,
  Cms_Group,
  Cms_Submilestone,
} from 'gatsby-graphql-types-generated'

export type JourneyChildType =
  | MilestoneCardFragment
  | SubmilestoneCardFragment
  | ArticleCardFragment
  | GroupCardFragment
  | ResourcePageCardFragment

const addResourcePages = (
  children: JourneyChildType[],
  resourcePages: ResourcePageCardFragment[] | null | undefined
) => {
  if (!(resourcePages && resourcePages.length)) return children

  let currentTileCount = 0

  // cycle through the resource pages
  let resourcePageIndex = 0
  const newIndex = (i: number) => (i === resourcePages.length - 1 ? 0 : i + 1)

  const maybeAddResourcePage = (
    children: JourneyChildType[],
    currentTileCount: number
  ) => {
    if (currentTileCount > 0 && currentTileCount % 2 === 1) {
      children.push(resourcePages[resourcePageIndex])
      resourcePageIndex = newIndex(resourcePageIndex)
      currentTileCount = 0
    }
  }

  return children.reduce<JourneyChildType[]>((acc, child, index) => {
    if (child.__typename === 'ContentfulJourneyTile') {
      currentTileCount += 1
      acc.push(child)

      // handle case where last child is a tile
      if (index === children.length - 1) {
        maybeAddResourcePage(acc, currentTileCount)
      }
    } else {
      maybeAddResourcePage(acc, currentTileCount)
      currentTileCount = 0
      acc.push(child)
    }

    return acc
  }, [])
}

const useProcessJourneyChildren = (
  journey: StaticJourneyPageFragment | StaticMilestonePageFragment,
  parentType: Cms_Group['__typename'] | Cms_Submilestone['__typename']
) => {
  const flattened = flatMap(journey.contentfulchildren, (child: any) => {
    if (child.contentfulchildren && child.__typename === parentType) {
      return [child, ...child.contentfulchildren]
    } else {
      return child
    }
  })

  return addResourcePages(flattened, journey.resourcePages)
}

export default useProcessJourneyChildren
